import { render, staticRenderFns } from "./AppealProcess.vue?vue&type=template&id=22ef33b0"
import script from "./AppealProcess.vue?vue&type=script&lang=ts"
export * from "./AppealProcess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports